<template lang="pug">
#measurepop(v-show="measureBoolean")
  ul
    li.item(v-for='(item,index) in meaureList' :key='index' :class="{'isActive':item.isActive}" @click='measureFunc(item,index)')
      van-image(width='25' height='25' :src='item.icon')
      span {{item.name}}
      //- van-image.right(v-if='item.isActive' :src='hookImg')
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      measureBoolean: true,
      meaureList: [
        { name: "标高测量", icon: require("./../../images/modelImage/level.png"), label: Monge.MeasureType3D.LEVEL, query: "LEVEL", isActive: false },
        { name: "面对面", icon: require("./../../images/modelImage/face.png"), label: Monge.MeasureType3D.FACE, query: "FACE", isActive: false },
        { name: "角度测量", icon: require("./../../images/modelImage/net.png"), label: Monge.MeasureType3D.ANGLE, query: "ANGLE", isActive: false },
        { name: "距离测量", icon: require("./../../images/modelImage/distance.png"), label: Monge.MeasureType3D.DISTANCE, query: "DISTANCE", isActive: false },
        { name: "最小距离", icon: require("./../../images/modelImage/mini.png"), label: Monge.MeasureType3D.MINI, query: "MINI", isActive: false },
        { name: "清除测量", icon: require("./../../images/modelImage/clear.png"), query: "clear", isActive: false }
      ],
      hookImg: require("./../../images/hook.png")
    };
  },
  methods: {
    async measureFunc(item, index) {
      if (item.query == "clear") {
        mongeApiMlib.clearMeasure();
        return;
      }
      this.measureBoolean = false;
      mongeApiMlib.measureH53D(item.label, {
        callback: (type) => {
          if (type === Monge.CallbackType.DONE) {
            this.measureBoolean = true;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#measurepop{
  position: fixed;
  bottom: 70px;
  left: 12px;
  width: calc(100% - 24px);
  height: 150px;
  max-height: calc(100% - 210px);
  z-index: 1;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  ul{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 10px 0;
    li{
      height: 44px;
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      span{
        margin-left: 7px;
        font-size: 16px;
        color: #2C303B;
      }
      .van-image{
        width: 25px;
        height: 25px;
      }
    }
    .isActive{
      background: rgba(56, 115, 254, 0.13);
      span{
        color: var(--theme-color);
      }
    }
    span{
      color: #dddddd;
    }
    .right{
      margin-left: auto;
    }
  }
  // ul::-webkit-scrollbar{width: 0 !important;}
  // ul{-ms-overflow-style: none;}
  // ul{overflow: -moz-scrollbars-none;}
}
</style>
